var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "vehicle-details text-center" },
    [
      _c(
        "div",
        { staticClass: "vehicle-image" },
        [_c("trim-image", { attrs: { trim: _vm.trim } })],
        1
      ),
      _vm._v(" "),
      _c("h1", [
        _vm._v(
          _vm._s(_vm.trim.year) +
            " " +
            _vm._s(_vm.trim.make) +
            " " +
            _vm._s(_vm.trim.model)
        )
      ]),
      _vm._v(" "),
      _c("h2", [_vm._v(_vm._s(_vm.trim.trim) + " " + _vm._s(_vm.trim.name))]),
      _vm._v(" "),
      _c("div", { staticClass: "details" }, [
        _vm.baseTrim
          ? _c("p", [
              _vm._v(
                "\n            Includes select features of " +
                  _vm._s(_vm.baseTrimName) +
                  " model plus...\n        "
              )
            ])
          : _c("p", [
              _vm._v(
                "\n            Includes the following standard features...\n        "
              )
            ]),
        _vm._v(" "),
        _c(
          "ul",
          _vm._l(_vm.standardDiff, function(standard, key) {
            return _c("li", { key: key }, [
              _vm._v(
                "\n                " + _vm._s(standard.value) + "\n            "
              )
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("b-link", { on: { click: _vm.viewAll } }, [
              _vm._v("\n                View All\n            ")
            ])
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("action-buttons", { attrs: { trim: _vm.trim } })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }